module.exports = __webpack_public_path__ + "img/empty-state.73e8aac2.svg";